export default {
  bindings: {
    scene: '<'
  },
  template: require('./scene.component.html').default
}
